import axios from 'axios';

// API - v1
export const v1AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});
// API - v1 Request 인터셉터 추가
v1AxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// API - v1 Response 인터셉터 추가
v1AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 내재화 - API v2
export const v2AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_RENEWAL_API_URL}`,
  withCredentials: true, // 인스턴스 생성 시 바로 설정
});
// 내재화 - API v2 Request 인터셉터 추가
v2AxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// Maps API - 상용
export const mapsv1AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_MAPS_URL}/${process.env.REACT_APP_MAP_KEY}`,
});
// Maps API - 상용 Request 인터셉터 추가
mapsv1AxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Maps API - 상용 Response 인터셉터 추가
mapsv1AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Maps API - 개발
export const devMapsB2BAxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_DEV_MAPS_B2B_URL}/${process.env.REACT_APP_MAP_KEY}`,
});
// Maps API - 개발 Request 인터셉터 추가
devMapsB2BAxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Maps API - 개발 Response 인터셉터 추가
devMapsB2BAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// TMAP
export const tmapv1AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_TMAP_URL}`,
});

// Request 인터셉터 추가
tmapv1AxiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response 인터셉터 추가
tmapv1AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
